export enum RegionStatusEnum {
    Ready = 'RDY',
    PendingConfiguration = 'PEC'
}
